export enum ParentMessageTypes {
  INIT_SUPPORT_APP = 'INIT_SUPPORT_APP',
  SHOW_SUPPORT_APP = 'SHOW_SUPPORT_APP',
  SHOW_MAIN_APP = 'SHOW_MAIN_APP',
  RELOAD = 'RELOAD',
  HIDE_LOADING = 'HIDE_LOADING',
}

export enum MainAppMessageTypes {
  REMOVE_USER_FROM_LOCAL_STORAGE = 'REMOVE_USER_FROM_LOCAL_STORAGE',
  CONTINUE_CONVERSATION = 'CONTINUE_CONVERSATION',
}

export enum SupportAppMessageTypes {
  START_CONVERSATION = 'START_CONVERSATION',
  RESET = 'RESET',
}
